import React, { FC } from 'react'
import { InitPageProps } from './InitPage-types'
import { styles } from './InitPage-styles'

export const InitPage: FC<InitPageProps> = ({ children }) => {
    return <div className={styles.initPage}>{children}</div>
}
